import SingleMatchLoad from './SingleMatchLoad'
import SingleMatchTruck from './SingleMatchTruck'

const MatchTransactions = ({ type, transactions, onRefresh, noMatchText }) => (
  transactions.length === 0
    ? <h5>{noMatchText}</h5>
    : (
      <table className="tennders-table-zebra">
        <tbody>
          {
            transactions?.map((stransaction) => (
              type === 'truck'
                ? <SingleMatchTruck key={stransaction.id} onRefresh={onRefresh} toMatch={stransaction} />
                : <SingleMatchLoad key={stransaction.id} onRefresh={onRefresh} toMatch={stransaction} />
            ))
          }
        </tbody>
      </table>
    )
)

export default MatchTransactions
